import { render, staticRenderFns } from "./dashboardTijianjigourenshu2.vue?vue&type=template&id=134a094d&scoped=true"
import script from "./dashboardTijianjigourenshu2.vue?vue&type=script&lang=js"
export * from "./dashboardTijianjigourenshu2.vue?vue&type=script&lang=js"
import style0 from "./dashboardTijianjigourenshu2.vue?vue&type=style&index=0&id=134a094d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134a094d",
  null
  
)

export default component.exports